<form [formGroup]="form" (ngSubmit)="onSubmit(form)">
    <div class="modal-header">
        <h4 class="modal-title">Advanced Search</h4>
        <button type="button" class="btn btn-link cancel" (click)="activeModal.dismiss('cancel')"><i class="fas fa-times"></i></button>    </div>
    <div class="modal-body">
        <div class="form-group">
            <label class="form-label">Name: </label>
            <input type="Name" formControlName="Name" class="form-control" placeholder="Name">
        </div>
        <div class="form-group">
            <label class="form-label">Filter By:</label>
            <select formControlName="Status" class="form-select filter-status">
                <option *ngFor="let status of Statuses" [value]="status.value" [disabled]="status.disabled">{{status.label}}</option>
            </select>
        </div>
        <div class="form-group" *ngIf="Approvers && Approvers.length > 0">
            <label class="form-label">Approver:</label>
            <select formControlName="ApproverUserId" class="form-select approvers-selector">
                <option value="">All Approvers</option>
                <option *ngFor="let approver of Approvers" [value]="approver.UserID">{{approver.DisplayName}}</option>
            </select> 
        </div>
        <div class="form-group" *ngIf='isAct48Enabled'>
            <label class="form-label">Act 48 Status</label>
            <select formControlName="Act48Status" class="form-select act-48-status">
                <option *ngFor="let status of A48_STATUS_FILTERS" [ngValue]="status.value" [disabled]="status.disabled">{{status.label}}</option>
            </select>
        </div>
        <div class="form-group" *ngIf="Groups && Groups.length > 0">
            <ngb-accordion [closeOthers]="true" activeIds="ngb-panel-0">
                <ngb-panel>
                    <ng-template ngbPanelTitle>
                        <span class="panel-title">Groups ({{selectedGroupsCount}})</span>
                        <span class="panel-sub-title">
                            <button type="button" class="btn btn-secondary ps-2 pe-2" (click)="onClearGroupsClicked($event)">Clear All</button>
                        </span>
                    </ng-template>
                    <ng-template ngbPanelContent>
                        <div class="groups mb-2">
                            <ul formArrayName="Groups" class="groups-selector">
                                <li *ngFor="let group of Groups; let i = index">
                                    <input type="checkbox" [formControlName]="i" (change)="setSelectedGroupCount()" id="group_{{i}}" /> 
                                    <label class="ms-2 form-label" for="group_{{i}}">{{ group.GroupName }}</label>
                                </li>
                            </ul>
                        </div>
                    </ng-template>
                </ngb-panel>
            </ngb-accordion>
        </div>
    </div>
    <div class="modal-footer">
        <button type="submit" class="btn btn-primary yes-button">Search</button>
        <button type="button" class="btn btn-info clear-button" (click)="clear()">Clear</button>
    </div>
</form>
